import { retry } from '@change-corgi/core/http';
import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { EmbeddedMedia, type EmbeddedMediaQuery, type EmbeddedMediaQueryVariables } from './getIframelyData.graphql';

type IframelyResponse = {
	html: string;
};

type IframelyOptions = EmbeddedMediaQueryVariables['input'];

// Params are passed to Iframely to customize style.
// Response type is something that extends IframelyResponse - Iframely might respond with different data per URL,
// but there's always at least a "html" property.
// Iframely doc: https://iframely.com/docs/oembed-api
export async function getIframelyData<RESPONSE extends IframelyResponse = IframelyResponse>(
	options: IframelyOptions,
	{ gql: { fetch } }: UtilityContext,
): Promise<RESPONSE> {
	const { data } = await retry({
		task: async () =>
			fetch<EmbeddedMediaQuery, EmbeddedMediaQueryVariables>({
				query: EmbeddedMedia,
				variables: {
					input: options,
				},
				rejectOnError: true,
			}),
		attempts: 3,
		delay: 250,
	});

	if (data.embeddedMedia.__typename === 'EmbeddedMediaError') throw new Error('media fetch failed');

	return data.embeddedMedia.media.rawData as RESPONSE;
}
